import {
  ApeironReactPlayer,
  MayNull,
  noForwardProps,
  useFetchYoutubeJson,
  YoutubeJson
} from '@apeiron/temp'
import { Box, keyframes, styled } from '@mui/material'
import { YoutubeAutoplayBlock } from '@src/types/pageBuilder'
import * as R from 'ramda'
import { useEffect, useMemo } from 'react'

const Container = styled(Box, noForwardProps)<CotnainerProps>`
  border-radius: 8px;
  background-color: #ffffff33;
  box-shadow: 0px 0px 250px #07c3d4cc;
  max-width: ${props => `${props.__maxWidth}px`};
  overflow: hidden;
  padding: 8px;
  position: relative;
  width: 100%;
`

const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0.7;
    width: 150%;
  }
  50% {
    opacity: 1;
    width: 200%;
  }
`

const Background = styled(Box, noForwardProps)<BackgroundProps>`
  filter: blur(20px) brightness(1.2);
  background-color: unset;
  background: url(${props => props.__background}) no-repeat center center;
  background-size: 150%;
  position: absolute;
  width: 150%;
  height: 150%;

  animation: ${fadeInOut} 5s infinite;
`

const Player = styled(Box)`
  position: relative;
  overflow: hidden;
`

const YoutubeAutoplayBlockView = (props: Props) => {
  const { autoplay, layoutProps, url } = props

  const { data, fetch } = useFetchYoutubeJson()

  const youtubeJson = useMemo((): MayNull<YoutubeJson> => {
    return R.isNotNil(data) && R.isNotEmpty(data) ? R.head(data) : null
  }, [data])

  useEffect(() => {
    if (R.isNotNil(url)) {
      fetch([url])
    }
  }, [url])

  return R.isNotNil(youtubeJson) ? (
    <Container __maxWidth={layoutProps.maxWidth}>
      <Background __background={youtubeJson.image} />
      <Player>
        <ApeironReactPlayer autoplay={autoplay} url={youtubeJson.url} />
      </Player>
    </Container>
  ) : null
}

type BackgroundProps = {
  __background: string
}

type CotnainerProps = {
  __maxWidth: number
}

type Props = {
  autoplay: boolean
  layoutProps: YoutubeAutoplayBlock['layoutProps']
  url: string
}

export default YoutubeAutoplayBlockView
